import React from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

// Last line of defence for the case the delivery summary warns about: access is
// granted but nobody is told, which is indistinguishable from a share that
// failed. Only raised when there are recipients to notify — sharing with nobody
// selected is not a notification problem.
export default function ShareDialogSilentShareConfirm({
    assetType,
    onCancel,
    onConfirm,
    open,
    recipientCount,
}) {
    const people = `${recipientCount} ${
        recipientCount === 1 ? "person" : "people"
    }`;

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs">
            <DialogTitle>Share without notifying anyone?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {people} will be given access to this {assetType}, but no
                    notification or email will be sent. They will not know it
                    has been shared unless you tell them another way.
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                <Button color="inherit" onClick={onCancel}>
                    Review settings
                </Button>
                <Button
                    variant="contained"
                    disableElevation
                    onClick={onConfirm}
                >
                    Share anyway
                </Button>
            </DialogActions>
        </Dialog>
    );
}
